import React from 'react';
import { styled, SvgIcon, Badge } from '@teko/ui';
import { useRouter } from 'next/router';
import { useCartV2, useTenantConfig } from '../../../contexts';
import dynamic from 'next/dynamic';
import { TekoLink } from '@teko/teko-ecommerce';

const ShoppingCartFilled = dynamic(() =>
  import('@teko/ds-icon').then((mod) => mod.ShoppingCartFilled),
);

const NewLayoutShoppingCartOutlined = dynamic(() =>
  import('@teko/ds-icon').then((mod) => mod.NewLayoutShoppingCartOutlined),
);

const IconCart = styled(TekoLink)`
  padding: 8px;
  position: relative;
`;

const StyledIcon = styled(SvgIcon)`
  display: block;
`;

interface CartHeaderProps {
  iconSize?: number;
  iconColor?: string;
  badgeTop?: number;
  badgeRight?: number;
  badgeWidth?: number;
  clickCart?: () => void;
  type?: 'filled' | 'outlined';
}

export const CartHeader: React.FC<CartHeaderProps> = ({
  iconSize = 20,
  iconColor,
  badgeTop = 0,
  badgeRight = 0,
  badgeWidth = 16,
  clickCart,
  type = 'outlined',
  ...rest
}: CartHeaderProps) => {
  const router = useRouter();
  const { totalCartItems } = useCartV2();
  const { displayNewLayout } = useTenantConfig();

  const clickToCart = clickCart
    ? clickCart
    : (): void => {
        router.push('/cart').then(() => window.scrollTo(0, 0));
      };

  return (
    <IconCart
      {...rest}
      onClick={(e) => {
        e.preventDefault();
        clickToCart();
      }}
      href="/cart"
    >
      {type === 'outlined' ? (
        displayNewLayout ? (
          <NewLayoutShoppingCartOutlined size={iconSize} color={iconColor} />
        ) : (
          <StyledIcon name="shopping-cart" size={iconSize} color={iconColor} />
        )
      ) : (
        <ShoppingCartFilled size={iconSize} color={iconColor} />
      )}
      {totalCartItems > 0 && (
        <Badge
          className="cart-badge"
          width={badgeWidth}
          text={`${totalCartItems}`}
          top={badgeTop}
          right={badgeRight}
        />
      )}
    </IconCart>
  );
};
